export const SET_STEP = 'SET_STEP'
export const SET_USER = 'SET_USER'
export const RESET = 'RESET'
